export enum EPage {
  Map = "MapPage",
  Lore = "LorePage",
  List = "ListPage",
}
